import { render, staticRenderFns } from "./ConferenceSettings.vue?vue&type=template&id=9af533a6&scoped=true"
import script from "./ConferenceSettings.vue?vue&type=script&lang=js"
export * from "./ConferenceSettings.vue?vue&type=script&lang=js"
import style0 from "./ConferenceSettings.vue?vue&type=style&index=0&id=9af533a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af533a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9af533a6')) {
      api.createRecord('9af533a6', component.options)
    } else {
      api.reload('9af533a6', component.options)
    }
    module.hot.accept("./ConferenceSettings.vue?vue&type=template&id=9af533a6&scoped=true", function () {
      api.rerender('9af533a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Modal/ConferenceSettings.vue"
export default component.exports